import Vue from 'vue';
import Vuetify, { VRow } from 'vuetify/lib';

import '@/assets/styles/vuetify/vuetify-global.scss';

import de from 'vuetify/src/locale/de';

Vue.use(Vuetify, {
  components: {
    // A-la-carte´s treeshaking will not include necessary styles until we add this component -shrug-
    VRow
  }
});

const opts = {
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#589bad',
        secondary: '#d0c6a3',
        accent: '#9b9b9b',
        error: '#d30028',
        warning: '#d30028',
        info: '#2196f3',
        success: '#4caf50'
      }
    }
  },
  options: {
    customProperties: true
  },
  lang: {
    locales: { de },
    current: 'de'
  }
};

export default new Vuetify(opts);
